<app-help-header></app-help-header>
<main>
  <div class="content">
    <div class="container help-content">
      <div class="row">
        <div class="col-md-3">
          <app-help-menu class="hidden-sm"></app-help-menu>
        </div>
        <div class="col-md-9">
          <!-- Gateway Settings -->
          <section #h_GatewaySettings [@fadeInAnimation]>
            <h3 translate id="item-3-2">Gateway Settings</h3>
            <div translate class="sum">
              PowerPanel Gateway offers a streamlined way for users to add devices to the PowerPanel Cloud using the SNMP protocol.
            </div>
            <div class="list" #h_GatewaySettings_InitialSetup>
              <h5 translate>Initial Setup</h5>
              <div class="section">
                <ul>
                  <li translate>Download the <a style="text-decoration: underline !important;" href="https://www.cyberpower.com/global/en/product/sku/powerpanel_cloud#downloads" target="_blank">Gateway application</a>  and install it on your local PC.</li>
                  <li translate>After installation, launch the application, log in using your PowerPanel Cloud account and name your gateway.</li>
                  <li translate>Log in to the PowerPanel Cloud website and navigate to Gateway Settings. Your newly connected gateway will appear at the top of the page.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-gateway-1.jpg">
                </div>
              </div>
            </div>
            <div class="list" #h_GatewaySettings_SetupDiscovery>
              <h5 translate>Setup for Device Discovery</h5>
              <div class="section">
                <ul>
                  <li>
                    <strong translate class="strong black">SNMP Profile:</strong><br>
                    <span translate>The default SNMP Profile supports CyberPower, APC, and Eaton SNMP V1 with the community set to "public." You can add or edit the SNMP Profile as needed. Ensure that
                      SNMP settings, such as the community for SNMP V1 or the authentication key for SNMP V3, match the settings of your device.</span>
                  </li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-gateway-2.jpg">
                </div>
                <ul>
                  <li>
                    <strong translate class="strong black">Auto-Discovery:</strong><br>
                    <span translate>Create a Discovery Job to configure the discovery settings, including the SNMP Profile, Gateway, and the range of IP addresses.</span>
                  </li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-gateway-3.jpg">
                </div>
              </div>
            </div>
            <div class="list" #h_GatewaySettings_StartDiscovery>
              <h5 translate>Start Device Discovery</h5>
              <div class="section">
                <ul>
                  <li>
                    <strong translate class="strong black">Auto-Discovery:</strong><br>
                    <span translate>Run the previously configured discovery job. Once devices are discovered, they will appear in the table below.</span>
                  </li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-gateway-4.jpg">
                </div>
                <ul>
                  <li>
                    <strong translate class="strong black">Connected Device:</strong><br>
                    <span translate>If you know the specific IP address of a device, navigate to Connected Device and click "Add Device." Select the gateway and SNMP profile, enter the IP address, and click "Continue" to start the discovery task.</span>
                  </li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-gateway-5.jpg">
                </div>
              </div>
            </div>
            <div class="list" #h_GatewaySettings_AddCloud>
              <h5 translate>Add Device to the Cloud</h5>
              <div class="section">
                <ul>
                  <li translate>After the discovery process is complete, the devices will be listed in the discovered devices table. Select and name the device you wish to add to the Cloud.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-gateway-6.jpg">
                </div>
                <ul>
                  <li translate>If you have an existing plan, the device will be added directly, allowing you to start monitoring it on the dashboard immediately. If you do not have a plan, you will need to purchase one.</li>
                </ul>
              </div>
            </div>
            <div class="list" #h_GatewaySettings_GatewayUpdate>
              <h5 translate>Gateway Update</h5>
              <div class="section">
                <ul>
                  <li translate>Click "Advanced Settings" to check the current Gateway version. You can update the Gateway version manually or toggle the "Automatic" setting to enable automatic updates for the Gateway.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-gateway-7.jpg">
                </div>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-gateway-8.jpg">
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</main>
